module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.service && parseInt(_vm.service.dispute_v2) !== 0 && (_vm.disputes && _vm.disputes.length > 0)) ? _c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Dispute V2")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [(_vm.disputes != null && _vm.disputes != '') ? _c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "card is-fullwidth",
    staticStyle: {
      "box-shadow": "0 2px 3px #A71C20, 0 0 0 1px #A71C20"
    }
  }, [_c('header', {
    staticClass: "card-header is-primary",
    staticStyle: {
      "box-shadow": "0 1px 0px #A71C20, 0 0 0 0px #A71C20",
      "background-color": "#A71C20"
    }
  }, [_c('p', {
    staticClass: "card-header-title is-primary",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("Dispute for: " + _vm._s(this.disputeType(_vm.service.dispute_type_v2)))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.service.dispute_status_v2 == 1 ? 'Open' : 'Closed')), _c('br'), _vm._v(" "), _c('b', [_vm._v("Type:")]), _vm._v(" " + _vm._s(this.disputeType(_vm.service.dispute_type_v2))), _c('br')])]), _vm._v(" "), _c('article', {
    staticClass: "media"
  }, [_c('pre', [_vm._v(_vm._s(_vm.disputes[0].dispute))])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "is-pulled-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.disputes[0].user.name))]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(_vm.disputes[0].created_at))])])])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.disputes), function(dispute) {
    return [(dispute.status != 1) ? _c('div', {
      staticClass: "column is-12"
    }, [_c('div', {
      staticClass: "card is-fullwidth"
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('pre', [_vm._v(_vm._s(dispute.dispute))]), _vm._v(" "), _c('p', [_c('small', {
      staticClass: "is-pulled-right"
    }, [_c('b', [_vm._v(_vm._s(dispute.user.name))]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(dispute.created_at))])])])])])])]) : _vm._e()]
  }), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99 && _vm.service.dispute_status_v2 < 2) ? _c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "card is-fullwidth"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title is-primary"
  }, [_vm._v(_vm._s(_vm.service.dispute_v2 == 0 ? 'Open Dispute' : 'Dispute'))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dispute.message),
      expression: "dispute.message"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "id": "message",
      "placeholder": "",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.dispute.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dispute, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('message')))])])]), _vm._v(" "), _c('p'), (_vm.service.dispute_status_v2 == 1) ? _c('div', {
    staticClass: "is-clearfix"
  }, [(_vm.service.dispute !== 0) ? _c('div', {
    staticClass: "is-clearfix"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Close To")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dispute.type),
      expression: "dispute.type"
    }],
    staticClass: "select is-pulled-right",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dispute, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.service.dispute_type_v2 === 3) ? _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("ALL")]) : _vm._e(), _vm._v(" "), (_vm.service.dispute_type_v2 === 1) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("CUSTOMER")]) : _vm._e(), _vm._v(" "), (_vm.service.dispute_type_v2 === 2) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("SUPPLIER")]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Close Option")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dispute.close_option),
      expression: "dispute.close_option"
    }],
    ref: "close_option",
    staticClass: "select",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dispute, "close_option", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("FULL CHARGE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("FREE CHARGES")])])]), _vm._v(" "), (parseInt(_vm.dispute.close_option) === 1) ? _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Provider Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dispute.provider_price),
      expression: "dispute.provider_price"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("required|decimal|max_value:" + (_vm.service.room.provider_price) + "|min_value:1")),
      expression: "`required|decimal|max_value:${service.room.provider_price}|min_value:1`"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('provider_price'),
      'is-disabled': parseInt(_vm.dispute.close_option) !== 1
    },
    attrs: {
      "name": "provider_price",
      "id": "provider_price",
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.dispute.provider_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dispute, "provider_price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('provider_price')),
      expression: "errors.has('provider_price')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('provider_price')))])]) : _vm._e(), _vm._v(" "), _c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    staticStyle: {
      "margin-top": "25px"
    },
    on: {
      "click": _vm.closeDispute
    }
  }, [_vm._v("Close Dispute")])]), _vm._v(" "), _c('a', {
    class: {
      'button': true,
      'is-warning': true,
      'is-pulled-right': true,
      'is-loading': _vm.inProgress,
      'is-disabled': _vm.errors.any() || _vm.inProgress
    },
    staticStyle: {
      "margin-top": "-42px"
    },
    on: {
      "click": _vm.replyDispute
    }
  }, [_vm._v("Save")])]) : _vm._e()]), _vm._v(" "), _c('p')])])]) : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38f9acce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/services/V2/Dispute.vue
// module id = 1109
// module chunks = 39